import { createAction, props } from '@ngrx/store';
import { ServicingSeatmapState } from './servicing-seatmap.state';

/** StateDetailsActions */
const ACTION_SET = '[ServicingSeatmap] set';
const ACTION_UPDATE = '[ServicingSeatmap] update';
const ACTION_RESET = '[ServicingSeatmap] reset';

/**
 * Clear the current store object and replace it with the new one
 */
export const setServicingSeatmap = createAction(ACTION_SET, props<ServicingSeatmapState>());

/**
 * Change a part or the whole object in the store.
 */
export const updateServicingSeatmap = createAction(ACTION_UPDATE, props<Partial<ServicingSeatmapState>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetServicingSeatmap = createAction(ACTION_RESET);
